import { useState } from 'react';
import ContactService from '../../../../services/contact_service';
import { initialConfirm } from '../../../../utils';

const DeleteProfile = (props) => {
    const [confirm, setConfirm] = useState(initialConfirm);
    
    const askDelete = async () => {
        const lostAccess = await props.losesAccess?.();
        if (lostAccess) return;
        setConfirm({ open: true, message: `Desea eliminar el usuario "${props.user.PrincipalEmail}"`, loading: false, error: '' });
    };

    const closeDeleteModal = () => {
        setConfirm(initialConfirm);
    };

    const handleConfirmDelete = async () => {
        const lostAccess = await props.losesAccess?.();
        if (lostAccess) return;
        props.setLoading(true);
        try {
            await ContactService.delete(props.user.Id)
            props.message('Usuario eliminado con éxito', 'success');
            props.onLogout()
        } catch (e) {
            props.message(e?.message || e, 'error');
        } finally {
            props.setLoading(false);
            closeDeleteModal()
        }
    };

    const handleCloseModal = () => {
        if (props.loading) return;
        setOpenModal(false);
        setName('');
    };

    return {
        confirm,
        askDelete,
        closeDeleteModal,
        handleConfirmDelete,
        handleCloseModal
    }
};

export default DeleteProfile;
